import ApiClient from '@package/services/src/ApiClient';
import Result from '@package/services/src/Result';

import { TopBannerService } from './services';
import { ContentResponse } from './types';

export default class TopBannerApiService implements TopBannerService {
  public constructor(private apiClient: ApiClient) {}

  public async getTopBannerContent(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/promotion-type/WebBanner');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('Top Banner Content was not received', error);
      return new Result(undefined);
    }
  }
}
